export var JoyAnalyticsServiceDataKey;
(function (JoyAnalyticsServiceDataKey) {
    JoyAnalyticsServiceDataKey["category"] = "category";
    JoyAnalyticsServiceDataKey["action"] = "action";
    JoyAnalyticsServiceDataKey["parameters"] = "parameters";
})(JoyAnalyticsServiceDataKey || (JoyAnalyticsServiceDataKey = {}));
export var JoyAnalyticsServiceEventCategory;
(function (JoyAnalyticsServiceEventCategory) {
    JoyAnalyticsServiceEventCategory["screens"] = "screens";
    JoyAnalyticsServiceEventCategory["users"] = "users";
    JoyAnalyticsServiceEventCategory["groups"] = "groups";
    JoyAnalyticsServiceEventCategory["group_members"] = "group_members";
    JoyAnalyticsServiceEventCategory["albums"] = "albums";
    JoyAnalyticsServiceEventCategory["media"] = "media";
    JoyAnalyticsServiceEventCategory["comments"] = "comments";
    JoyAnalyticsServiceEventCategory["auth"] = "auth";
    JoyAnalyticsServiceEventCategory["selection"] = "selection";
})(JoyAnalyticsServiceEventCategory || (JoyAnalyticsServiceEventCategory = {}));
export var JoyAnalyticsServiceEventAction;
(function (JoyAnalyticsServiceEventAction) {
    JoyAnalyticsServiceEventAction["create"] = "create";
    JoyAnalyticsServiceEventAction["edit"] = "edit";
    JoyAnalyticsServiceEventAction["delete"] = "delete";
    JoyAnalyticsServiceEventAction["add"] = "sdd";
    JoyAnalyticsServiceEventAction["remove"] = "remove";
    JoyAnalyticsServiceEventAction["download"] = "download";
    JoyAnalyticsServiceEventAction["like"] = "like";
    JoyAnalyticsServiceEventAction["share"] = "share";
    JoyAnalyticsServiceEventAction["play"] = "play";
    JoyAnalyticsServiceEventAction["cancel"] = "cancel";
    JoyAnalyticsServiceEventAction["start"] = "start";
    JoyAnalyticsServiceEventAction["stop"] = "stop";
    JoyAnalyticsServiceEventAction["login"] = "login";
    JoyAnalyticsServiceEventAction["select"] = "select";
    JoyAnalyticsServiceEventAction["deselect"] = "deselect";
})(JoyAnalyticsServiceEventAction || (JoyAnalyticsServiceEventAction = {}));
export default class JoyAnalyticsService {
    static add(destination) {
        this.destinations.push(destination);
    }
    static setUserId(userId) {
        this.destinations.forEach((destination) => {
            destination.setUserId(userId);
        });
    }
    static sendTaskStart(name) {
        this.destinations.forEach((destination) => {
            destination.sendStartEvent(name);
        });
    }
    static sendTaskEnd(name) {
        this.destinations.forEach((destination) => {
            destination.sendEndEvent(name);
        });
    }
    static sendEvent(category, parameters, action) {
        let data = new Map();
        data[JoyAnalyticsServiceDataKey.category] = category;
        data[JoyAnalyticsServiceDataKey.parameters] = parameters;
        if (action !== null) {
            data[JoyAnalyticsServiceDataKey.action] = action;
        }
        this.destinations.forEach((destination) => {
            destination.sendEvent(data);
        });
    }
    static reset() {
        this.destinations.forEach((destination) => {
            destination.reset();
        });
    }
}
JoyAnalyticsService.destinations = [];
//# sourceMappingURL=JoyAnalyticsService.js.map